
const HistoryStyle = theme => ({
    emailWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "auto"
    },
    fixHistoryHeaderWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    tableHeader: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flex: 1,
        minHeight: 35,
        maxHeight: 35,
        backgroundColor: "#eaeded"
    },
    emptyRow: {
        paddingTop: 14,
        paddingLeft: 43,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "18px",
        letterSpacing: 0,
        lineHeight: "22px",
        display: "flex",
        minHeight: 100
    },
    dateSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 100,
        minWidth: 100,
        marginRight: "20px",
        marginLeft: "20px"
    },
    orderSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 180,
        marginRight: "20px"
    },
    products: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        display: "flex",
        flex: 1,
        marginRight: "20px"
    },
    orderType: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 82,
        textAlign: "center",
        minWidth: 82,
        marginRight: "20px"
    },
    approval: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 106,
        textAlign: "center",
        minWidth: 106,
        marginRight: "20px"
    },
    orderStatus: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 95,
        textAlign: "center",
        minWidth: 95,
        marginRight: "20px"
    },
    historyRowWrapper: {
        borderBottom: "2px solid #ededed",
        display: "flex",
        width: "100%",
        flexShrink:0,
        paddingTop: 6.5,
        paddingBottom: 6.5,
        backgroundColor: "#ffffff"
    },
    historyOddRowWrapper: {
        flexShrink:0,
        backgroundColor: "#fafafa !important"
    },
    dateRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        marginRight: "20px",
        marginLeft: "20px",
        lineHeight: "17px",
        width: 100,
        minWidth: 100,
    },
    orderNumber: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        display: "flex",
        justifyContent: "space-between",
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
        width: 180,
        minWidth: 180,
    },
    newWindowIcon: {
        height: 17,
        width: 16,
        maxWidth: 16,
        maxHeight: 17,
        minWidth: 16,
        marginRight: 15,
        cursor: "pointer"
    },
    productsRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
        display: "flex",
        flex: 1,
    },
    orderTypeRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        width: 82,
        minWidth: 82,
        letterSpacing: 0,
        textAlign: "center",
        marginRight: 20,
        lineHeight: "17px",
    },
    approvalRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        width: 106,
        textAlign: "center",
        minWidth: 106,
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
    },
    orderStatusRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        width: 95,
        textAlign: "center",
        minWidth: 95,
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
    },

    ellipsis: {
        whiteSpace: "pre-wrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block !important",
        width: "100%"
    },
    historyProductWrapper: {
        display: "flex",
        flex: 1
    },
    historyProductContainer: {
        display: "flex",
        flex: 1,
        flexDirection: "column"
    }
})

export default HistoryStyle;